<template>
  <div class="vx-row">
    <div v-if="labelTop" class="vx-col w-full">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="label">{{ labelTop }}</div>
        </div>
      </div>
    </div>

    <div class="vx-col w-1/2">
      <img :style="`max-width:100%;max-height:${maxHeight};`"
        :id="`${identifier}itoviImageUploadPreview`"
        :src="initialImageUrl"
        class="grid-view-img p-4" />
    </div>
    <div class="vx-col w-1/2 center-container">
      <form :id="`${identifier}itoviImageForm`" method="post" enctype="multipart/form-data">
        <label :id="`${identifier}fileInputLabel`" :for="`${identifier}fileInput`" class="upload-button-center">
          <vs-button type="gradient" icon="add_a_photo" @click="document.getElementById(`${identifier}fileInputLabel`).click()"><span v-if="buttonText">{{ buttonText }}</span></vs-button>
        </label>
        <input :id="`${identifier}fileInput`" type="file" name="image" @input="validateImage" />
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ItoviImageUpload",
    data() {
      return {
        document: document,
      }
    },
    async created() {
      if (this.requiredAspectRatio && this.requiredWidth && this.requiredHeight) {
        throw new Error('You can only supply either requiredAspectRatio or width/height, not both.');
      }
    },
    props: {
      identifier: {
        type: String,
        required: true,
      },
      initialImageUrl: {
        type: String,
        required: false,
        default: () => {
          return '';
        },
      },
      maxHeight: {
        type: String,
        required: false,
        default: () => {
          return '200px';
        },
      },
      labelTop: {
        type: String,
        required: false,
        default: () => {
          return '';
        },
      },
      buttonText: {
        type: String,
        required: false,
        default: () => {
          return '';
        },
      },
      requiredWidth: {
        type: Number,
        required: false,
        default: () => {
          return null;
        },
      },
      requiredHeight: {
        type: Number,
        required: false,
        default: () => {
          return null;
        },
      },
      requiredAspectRatio: {
        type: Number,
        required: false,
        default: () => {
          return null;
        },
      },
    },
    methods: {
      async validateImage(event) {
        let file;
        try {
          file = event.target.files[0];
        } catch (e) {
          console.log(e);
        }
        if (!file) {
          this.showNotification(false, 'No image found');
          return;
        }

        await this.showSelectedImage(file);
        // await new Promise(resolve => setTimeout(resolve, 250));
        let imgElement = document.getElementById(`${this.identifier}itoviImageUploadPreview`);

        // validate the size/aspect ratio
        if (this.requiredAspectRatio !== null || (this.requiredWidth !== null && this.requiredHeight !== null)) {
          let newImg = new Image();
          newImg.src = imgElement.getAttribute('src');
          let height = newImg.height;
          let width = newImg.width;
          if (this.requiredAspectRatio !== null) {
            // round to the 2 decimal places for comparison
            let aspectRatio = Math.round((width/height) * 100) / 100;
            // round to the 2 decimal places for comparison
            let required = Math.round(this.requiredAspectRatio * 100) / 100;
            if (aspectRatio !== required) {
              this.showNotification(false, `Aspect ratio of ${required} required. The selected image has an aspect ratio of ${aspectRatio}.`);
              this.showInitialImage();
              return;
            }
          } else {
            if (width !== this.requiredWidth || height !== this.requiredHeight) {
              this.showNotification(false, `Image size of ${this.requiredWidth}x${this.requiredHeight} required. The selected image has an aspect ratio of ${width}x${height}.`);
              this.showInitialImage();
              return;
            }
          }
        }



        this.$emit('imageSelected', file);


      },
      showInitialImage() {
        let imgElement = document.getElementById(`${this.identifier}itoviImageUploadPreview`);
        imgElement.setAttribute('src', this.initialImageUrl);
      },
      showSelectedImage(file) {
        return new Promise((accept) => {
          let img = document.getElementById(`${this.identifier}itoviImageUploadPreview`);
          let reader = new FileReader();
          reader.onloadend = function() {
            img.src = reader.result;
            accept();
          };
          reader.readAsDataURL(file);
        });
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    },
  }
</script>

<style scoped>
  input[type="file"] {
    display: none;
  }
  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
  }
  .grid-view-img-top {
    position: absolute;
    left: 0;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
  }
  .center-container {
    position: relative;
  }
  .upload-button-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
</style>
